import React, { Fragment } from "react";
import man from "../../../assets/images/dashboard/user.png";
import { Link } from "react-router-dom";
import { Edit } from "react-feather";
import { useSelector } from "react-redux";

const UserPanel = () => {
  const { user } = useSelector((state) => state.auth);
  const url = user?.profile_image_url;
  const user_name =
    user?.first_name && user?.last_name
      ? user.first_name + " " + user.last_name
      : user?.email.split(".", 1);

  return (
    <Fragment>
      <div className="sidebar-user text-center">
        <div>
          <img
            className="img-60 rounded-circle lazyloaded blur-up"
            height={60}
            width={60}
            src={url ? url : man}
            alt=""
          />
          <div className="profile-edit">
            <Link to="/edit-profile">
              <Edit />
            </Link>
          </div>
        </div>
        <h6
          className="mt-3 f-14"
          style={{ color: "#222222", minHeight: "16px" }}
        >
          {user_name}
        </h6>
      </div>
    </Fragment>
  );
};

export default UserPanel;
